import React, { useState } from "react";
import styled from "styled-components";
import KakaoAd from "./components/KakaoAd";
import ResultScreen from "./components/ResultScreen";
import Stage1 from "./components/Stage1";
// import Stage10 from "./components/Stage10";
import Stage2 from "./components/Stage2";
import Stage3 from "./components/Stage3";
import Stage4 from "./components/Stage4";
import Stage5 from "./components/Stage5";
import Stage6 from "./components/Stage6";
import Stage7 from "./components/Stage7";
// import Stage8 from "./components/Stage8";
// import Stage9 from "./components/Stage9";
import TypingScreen from "./components/TypingScreen";
import ReactGA from "react-ga4";

const gaTrackingId = "G-3F9QRTV8BC";
ReactGA.initialize(gaTrackingId);
ReactGA.send("pageview");

function App() {
  const [screen, setScreen] = useState("main");

  return (
    <Container>
      <KakaoAd adUnit="DAN-X0DqdzHx7EPfHTAV" adWidth="320" adHeight="100" />

      {screen === "main" && (
        <TypingScreen onClickNext={() => setScreen("stage1")} />
      )}
      {screen === "stage1" && <Stage1 setScreen={setScreen} />}
      {screen === "stage2" && <Stage2 setScreen={setScreen} />}
      {screen === "stage3" && <Stage3 setScreen={setScreen} />}
      {screen === "stage4" && <Stage4 setScreen={setScreen} />}
      {screen === "stage5" && <Stage5 setScreen={setScreen} />}
      {screen === "stage6" && <Stage6 setScreen={setScreen} />}
      {screen === "stage7" && <Stage7 setScreen={setScreen} />}
      {/* {screen === "stage8" && <Stage8 setScreen={setScreen} />}
      {screen === "stage9" && <Stage9 setScreen={setScreen} />}
      {screen === "stage10" && <Stage10 setScreen={setScreen} />} */}
      {screen === "result" && <ResultScreen setScreen={setScreen} />}
    </Container>
  );
}

export default App;

const Container = styled.div`
  width: 100%;
  /* height: 100vh; */
  min-height: calc(100vh - 100px);
  background-color: black;
`;
